import $ from 'cash-dom';
import CallButtonAnimationHandler from '../parts/ppc/CallButtonAnimationHandler';

const CallboxLoader = {
	usePostponedLoad: false,
	callboxScriptAppended: false,
	animationInitialized: false,

	_getScriptSrc() {
		if (window.location.host === 'www.pawlicywizard.com' || window.location.host ===  'www.pawlicyguru.com') {
			return "https://418786.tctm.xyz/t.js";
		} else if (window.location.host === 'www.mortgage-insiders.com') {
			return "https://506563.tctm.xyz/t.js";
		} else if (window.location.host === 'www.bestgoldinvestor.com') {
			return "https://581444.tctm.co/t.js";
		} else {
			return "https://381729.tctm.co/t.js";
		}
	},

	_appendScript() {
		if (this.callboxScriptAppended) {
			return;
		}

		const scriptSrc = this._getScriptSrc();
		const script = document.createElement('script');

		script.async = true;
		script.src = scriptSrc;

		script.onload = () => {
			this._waitForCallboxAndInitAnimation();
		};

		document.body.appendChild(script);
		this.callboxScriptAppended = true;
	},

	appendScript() {
		if (this.usePostponedLoad) {
			setTimeout(() => {
				this._appendScript();
			}, 3000);
		} else {
			this._appendScript();
		}
	},

	hasPhones(element) {
		let telephones = element.find('[href^="tel:"]'),
			hasPhones = false;

		telephones.each((i, phoneEl) => {
			if ($(phoneEl).css('display') !== 'none') {
				hasPhones = true;
				return false;
			}
		});

		return hasPhones;
	},

	_waitForCallboxAndInitAnimation(retries = 30) {
		if (this.animationInitialized) {
			return;
		}

		const $buttons = $('.animated-mobile-phone-btn');

		if (!$buttons.length) {
			return;
		}

		let allTrackedOrNoSpan = true;

		$buttons.each((i, el) => {
			const $btn = $(el);
			const $numberEl = $btn.find('.call-btn-number');

			if (!$numberEl.length) {
				return;
			}

			const tracked = $numberEl.attr('data-ctm-tracked');

			if (tracked !== '1') {
				allTrackedOrNoSpan = false;
			}
		});

		if (allTrackedOrNoSpan || retries <= 0) {
			this.animationInitialized = true;
			CallButtonAnimationHandler.getInstance().init();
			return;
		}

		setTimeout(() => {
			this._waitForCallboxAndInitAnimation(retries - 1);
		}, 100);
	},

	init() {
		this.usePostponedLoad =
			window.location.pathname === '/top/mortgage-purchase-callbox-delayed/' ||
			window.location.pathname === '/top/mortgage-refinance-copy/';

		this.callboxScriptAppended =
			$(document.body).find('[src="' + this._getScriptSrc() + '"]').length !== 0;

		const hasPhones = this.hasPhones($(document.body));

		if (!hasPhones) {
			return;
		}

		if (this.usePostponedLoad) {
			$('[href^="tel:"]').on('click', (e) => {
				if (!this.callboxScriptAppended) {
					e.preventDefault();
				}
			});
		}

		this.appendScript();
	}
};

export default CallboxLoader;
